import type { InputSource } from '../types';
import { drawDisguiseLogo } from '../utils/draw-disguise-logo';

export function drawColorGrid(
  ctx: CanvasRenderingContext2D,
  width: number,
  height: number,
  x = 0,
  y = 0,
  gridDivsX = 10,
  gridDivsY = gridDivsX
) {
  const blockWidth = width / gridDivsX;
  const blockHeight = height / gridDivsY;

  // Corner colors for bilinear interpolation
  const c00 = { r: 255, g: 0, b: 0 }; // Top-left: Red
  const c10 = { r: 0, g: 255, b: 0 }; // Top-right: Green
  const c01 = { r: 255, g: 0, b: 255 }; // Bottom-left: Magenta
  const c11 = { r: 0, g: 0, b: 255 }; // Bottom-right: Blue

  for (let j = 0; j < gridDivsY; j++) {
    for (let i = 0; i < gridDivsX; i++) {
      const nx = i / (gridDivsX - 1);
      const ny = j / (gridDivsY - 1);

      const r = Math.round((1 - ny) * ((1 - nx) * c00.r + nx * c10.r) + ny * ((1 - nx) * c01.r + nx * c11.r));
      const g = Math.round((1 - ny) * ((1 - nx) * c00.g + nx * c10.g) + ny * ((1 - nx) * c01.g + nx * c11.g));
      const b = Math.round((1 - ny) * ((1 - nx) * c00.b + nx * c10.b) + ny * ((1 - nx) * c01.b + nx * c11.b));

      ctx.fillStyle = `rgb(${r},${g},${b})`;
      ctx.fillRect(x + i * blockWidth, y + j * blockHeight, blockWidth, blockHeight);
    }
  }

  // Draw grid lines between blocks
  ctx.strokeStyle = '#fff';
  ctx.lineWidth = 1;
  for (let i = 1; i < gridDivsX; i++) {
    ctx.beginPath();
    ctx.moveTo(x + i * blockWidth, y);
    ctx.lineTo(x + i * blockWidth, y + height);
    ctx.stroke();
  }
  for (let i = 1; i < gridDivsY; i++) {
    ctx.beginPath();
    ctx.moveTo(x, y + i * blockHeight);
    ctx.lineTo(x + width, y + i * blockHeight);
    ctx.stroke();
  }

  // Draw corner labels
  ctx.fillStyle = 'white';
  ctx.font = '30px Arial';

  ctx.textAlign = 'left';
  ctx.textBaseline = 'top';
  ctx.fillText('0,0', x + 10, y + 10);

  ctx.textAlign = 'right';
  ctx.textBaseline = 'top';
  ctx.fillText('1,0', x + width - 10, y + 10);

  ctx.textAlign = 'left';
  ctx.textBaseline = 'bottom';
  ctx.fillText('0,1', x + 10, y + height - 10);

  ctx.textAlign = 'right';
  ctx.textBaseline = 'bottom';
  ctx.fillText('1,1', x + width - 10, y + height - 10);

  drawDisguiseLogo(ctx, width, height, x, y);
}

export const colorGrid: InputSource = {
  label: 'Color Grid',
  value: 'colorGrid',
  draw: (ctx, width, height, options) => {
    drawColorGrid(ctx, width, height, 0, 0, options?.gridDivsX, options?.gridDivsY);
  },
};
